package com.arenaproplay.admin.domain.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AcqSummaryDto(
    @SerialName("newUsers") val newUsers: Long,
    @SerialName("attributed") val attributed: Long,
    @SerialName("active24hRate") val active24hRate: Double,
    @SerialName("proConversions") val proConversions: Long,
    @SerialName("proConversionRate") val proConversionRate: Double,
)

@Serializable
data class AcqSourceDto(
    @SerialName("source") val source: String,
    @SerialName("users") val users: Long,
    @SerialName("active24h") val active24h: Long,
    @SerialName("pro") val pro: Long,
    @SerialName("convRate") val convRate: Double,
    @SerialName("campaigns") val campaigns: List<AcqCampaignDto>,
)

@Serializable
data class AcqCampaignDto(
    @SerialName("campaign") val campaign: String,
    @SerialName("users") val users: Long,
    @SerialName("pro") val pro: Long,
)

@Serializable
data class AcqGeoDto(
    @SerialName("countries") val countries: List<AcqCountryCount>,
    @SerialName("topCities") val topCities: List<AcqCityCount>,
)

@Serializable
data class AcqCountryCount(
    @SerialName("country") val country: String,
    @SerialName("users") val users: Long,
    @SerialName("share") val share: Double,
)

@Serializable
data class AcqCityCount(
    @SerialName("city") val city: String,
    @SerialName("users") val users: Long,
)

@Serializable
data class AcqFunnelDto(
    @SerialName("installs") val installs: Long,
    @SerialName("signups") val signups: Long,
    @SerialName("firstAction") val firstAction: Long,
    @SerialName("returned7d") val returned7d: Long,
    @SerialName("pro") val pro: Long,
)

@Serializable
data class AcqInterestDto(
    @SerialName("screen") val screen: String,
    @SerialName("share") val share: Double,
)
